// Numeración automática de las fechas de una zona: "Fecha 1", "Fecha 2", ...
//
// El número no se guarda en el torneo: se deriva siempre de la zona, según el
// orden de juego (cronológico ascendente; las que todavía no tienen fecha
// calendario quedan al final, en el orden en que se crearon). Es el mismo
// criterio con el que la tabla de posiciones acumula los partidos, así que
// "Fecha 3" es siempre la tercera fecha jugada de esa zona.

const porFechaCalendario = (a, b) => {
  if (!a.date && !b.date) return 0;
  if (!a.date) return 1;
  if (!b.date) return -1;
  return a.date.localeCompare(b.date);
};

export function ordenarFechas(fechas = []) {
  return [...fechas].sort(porFechaCalendario);
}

// Para los listados: de la última fecha a la primera (Fecha 3, Fecha 2, Fecha 1).
export function ordenarFechasDesc(fechas = []) {
  return ordenarFechas(fechas).reverse();
}

// { [idDeFecha]: numero } para todas las fechas de la zona.
export function numerosDeFecha(fechas = []) {
  const numeros = {};
  ordenarFechas(fechas).forEach((f, index) => (numeros[f.id] = index + 1));
  return numeros;
}

export function numeroDeFecha(fechas = [], fechaId) {
  return numerosDeFecha(fechas)[fechaId] || null;
}

// Fecha calendario en texto. formato: "largo" (Lunes 3 de agosto) o "corto" (Lun 3 ago).
// Devuelve "" si la fecha todavía no tiene día asignado.
export function fechaCalendario(fecha, formato = "largo") {
  if (!fecha || !fecha.date) return "";
  const opciones =
    formato === "corto"
      ? { weekday: "short", day: "numeric", month: "short" }
      : { weekday: "long", day: "numeric", month: "long" };
  const texto = new Date(fecha.date + "T00:00:00").toLocaleDateString("es-AR", opciones);
  return texto.charAt(0).toUpperCase() + texto.slice(1);
}

// Rótulo completo para los listados: "Fecha 3 · Lunes 3 de agosto".
// Si la fecha todavía no tiene día asignado, queda solo "Fecha 3".
export function etiquetaFecha(fecha, numero, formato = "largo") {
  const rotulo = numero ? "Fecha " + numero : "Fecha";
  const calendario = fechaCalendario(fecha, formato);
  return calendario ? rotulo + " · " + calendario : rotulo;
}
